import { useEffect, useMemo, useState } from 'react';
import { tmdb } from '../lib/tmdb.js';
import { getLoves, getEjects, subscribeLikes } from '../lib/likes.js';
import { useAuth } from '../lib/auth.js';
import PosterCard from './PosterCard.jsx';

export default function ForYouShelf({ providerIds, onPosterClick, seedItemsOverride, ownerName, ejectsOverride }) {
  const { user, profile } = useAuth();
  const [loves, setLoves]   = useState(() => seedItemsOverride || getLoves());
  const [ejects, setEjects] = useState(() => ejectsOverride || getEjects());
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (seedItemsOverride) { setLoves(seedItemsOverride); }
    if (ejectsOverride)    { setEjects(ejectsOverride); }
    if (seedItemsOverride || ejectsOverride) return undefined;

    return subscribeLikes(({ loves: l, ejects: e }) => {
      setLoves(l); setEjects(e);
    });
  }, [seedItemsOverride, ejectsOverride]);

  const seedKey =
    loves.map((i) => `${i.media_type}:${i.tmdb_id}`).join(',') +
    '|' +
    ejects.map((i) => `${i.media_type}:${i.tmdb_id}`).join(',');

  useEffect(() => {
    if (loves.length === 0 && ejects.length === 0) {
      setResults([]); setLoading(false); return;
    }
    let alive = true;
    setLoading(true);
    tmdb.recommendations({ loves, ejects, providers: providerIds })
      .then((d) => alive && setResults(d.results || []))
      .catch(() => alive && setResults([]))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [seedKey, providerIds]);

  const who = ownerName || profile?.display_name || (user ? 'you' : 'you');
  const subtitle = loves.length
    ? `${who} loved ${loves.length} ${loves.length === 1 ? 'title' : 'titles'}${ejects.length ? ` · ejected ${ejects.length}` : ''}`
    : `${who} hasn’t loved anything yet — start hearting movies and shows to fill this shelf`;

  return (
    <section className="hb-shelf hb-shelf--foryou">
      <div className="hb-shelf__sign hb-shelf__sign--foryou">
        <h2 className="hb-shelf__title">For {who}</h2>
        <p className="hb-shelf__subtitle">{subtitle}</p>
      </div>

      <div className="hb-shelf__rail">
        {loading ? (
          Array.from({ length: 8 }).map((_, i) => <div key={i} className="hb-poster hb-poster--skeleton" />)
        ) : loves.length === 0 && ejects.length === 0 ? (
          <div className="hb-shelf__empty">No loves yet.</div>
        ) : results.length === 0 ? (
          <div className="hb-shelf__empty">No recommendations available on your services yet.</div>
        ) : (
          results.map((m) => (
            <PosterCard key={`${m.media_type}:${m.id}`} movie={m} onClick={() => onPosterClick?.(m)} />
          ))
        )}
      </div>
    </section>
  );
}
